<template>
  <v-app id="backGND">
    <navBar />
    <div id="triangle_down">
      <div id="triangle">
        <h1
          class="rotate"
          style="
            margin: auto;
            text-align: left;
            font-family: 'Poiret One', sans-serif;
            color: white;
            padding-left: 1rem;
            font-size: 3rem;
          "
        >
          Sube tu Video
        </h1>
      </div>
    </div>
    <div style="margin: auto; width: 18rem">
      <p style="font-size: 2rem"><b>Vas a subir un:</b></p>
      <v-select
        background-color="rgba(202,210,208,0.8)"
        color="black"
        @change="selectFilter"
        class="field centered_input"
        v-model="filter"
        outlined
        :items="filters"
      >
        <template v-slot:selection="{ item }">
          <span
            style="
              font-family: Karantina;
              font-size: 2rem;
              color: rgb(0, 0, 0);
              text-align: center;
              width: 100%;
            "
            >{{ item }}</span
          >
        </template>
      </v-select>
    </div>
    <!-- si no es Video de Stream -->
    <v-row v-if="'VIDEO' == filter" justify="center">
      <v-col cols="12" lg="6" md="8" sm="10">
        <v-card color="rgba(255,255,255,0.7)" elevation="10" rounded="xl">
          <v-form v-model="isFormValid">
            <v-container>
              <!-- Nombre del video -->
              <p class="form-subtitle"><b>Nombre del Video</b></p>
              <v-text-field
                class="field centered_input"
                required
                v-model="name"
                :rules="nameRules"
                type="text-center"
                clearable
              />
              <!-- Descripcion -->
              <p class="form-subtitle"><b>Descripción</b></p>
              <v-text-field
                class="field centered_input"
                required
                v-model="description"
                :rules="descriptionRules"
                type="text-center"
                clearable
              />
              <!-- Instructora -->
              <p class="form-subtitle"><b>Instructor(es)</b></p>
              <v-select
                class="field centered_input"
                v-model="instructor"
                outlined
                placeholder="Selecciona una opción"
                :items="instructors"
              >
                <template v-slot:selection="{ item }">
                  <span
                    style="
                      color: rgb(44, 81, 213);
                      text-align: center;
                      width: 100%;
                    "
                    >{{ item }}</span
                  >
                </template>
              </v-select>
              <!-- Fecha del video -->
              <p class="form-subtitle">
                <b>Fecha del video:</b>
                <br />
                <v-date-picker
                  v-model="datePicker"
                  color="green lighten-1"
                ></v-date-picker>
              </p>
              <!-- Categoria -->
              <p class="form-subtitle"><b>Categoria</b></p>
              <v-select
                class="field centered_input"
                v-model="category"
                outlined
                placeholder="Selecciona una opción"
                :items="categorys"
              >
                <template v-slot:selection="{ item }">
                  <span
                    style="
                      color: rgb(44, 81, 213);
                      text-align: center;
                      width: 100%;
                    "
                    >{{ item }}</span
                  >
                </template>
              </v-select>

              <!-- CARPETAS -->
              <p class="form-subtitle"><b>Pertenece A:</b></p>
              <v-dialog v-model="dialog" max-width="290">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Agregar Nueva Carpeta
                  </v-btn>
                </template>
                <v-card color="white">
                  <p class="form-subtitle"><b>Nueva Carpeta:</b></p>
                  <v-text-field
                    class="field centered_input"
                    required
                    v-model="newFolder"
                    :rules="descriptionRules"
                    type="text-center"
                    clearable
                  />
                  <v-btn class="mx-1" fab dark  small color="green" @click="saveNewFolder">
                    <v-icon dark> mdi-plus </v-icon>
                  </v-btn>
                  <br/>
                </v-card>
                <div
                  id="divider"
                  style="
                    background-color: black;
                    height: 0.5rem;
                    width: 80%;
                    margin: auto;
                  "
                ></div>
                <v-list>
                  <v-header>CARPETAS EXISTENTES</v-header>
                  <v-list-item v-for="item in folders" :key="item">
                    <v-list-item-content>
                      <v-list-item-title v-text="item">*</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-dialog>
              <br /><br />
              <v-select
                class="field centered_input"
                v-model="serie"
                outlined
                placeholder="Selecciona una opción"
                :items="folders"
              >
                <template v-slot:selection="{ item }">
                  <span
                    style="
                      color: rgb(44, 81, 213);
                      text-align: center;
                      width: 100%;
                    "
                    >{{ item }}</span
                  >
                </template>
              </v-select>
            </v-container>
          </v-form>

          <br />
          <!-- CARD DE LA IMAGEN --- Miniatura --->
          <p class="form-subtitle"><b>Miniatura</b></p>
          <img alt="Avatar" class="rouded" :src="this.url_img" width="50%" />
          <v-spacer />
          <v-progress-linear v-model="UploadValue"></v-progress-linear>
          <v-spacer />
          <input type="file" @change="onFileSelected" />
          <!-- CARD DE LA IMAGEN --- Video --->
          <p class="form-subtitle"><b>Video:</b></p>
          <v-card class="justify-center" color="rgba(255,255,255,0.7)">
            <v-card-text
              style="font-family: Karantina; font-size: 2rem; color: red"
              v-if="UploadValueVideo > 1 && flag_video == false"
              >Tu video se esta procesando, por favor espera.
            </v-card-text>
            <v-card-text
              v-else-if="flag_video == true"
              style="font-family: Karantina; font-size: 2rem; color: blue"
              >Video cargado correctamente</v-card-text
            >
          </v-card>
          <v-spacer />
          <v-progress-linear v-model="UploadValueVideo"></v-progress-linear>
          <v-spacer />
          <input type="file" @change="onFileSelectedVideo" />
          <v-btn rounded color="primary" @click="uploadBtn">SUBIR VIDEO </v-btn>
          <br />
          <p class="form-subtitle"><b>URL de YouTube:</b></p>

          <v-text-field
            class="field centered_input"
            required
            v-model="streamurl"
            :rules="descriptionRules"
            type="text-center"
            clearable
          />

          <!-- numero de video -->
          <p class="form-subtitle"><b>Número de Video:</b></p>
          <v-text-field
            class="field centered_input"
            v-model="numbervideo"
            type="text-center"
            clearable
          />
        </v-card>
        <br />
        <!-- BOTON DE GUARAR -->
        <v-btn
          :disabled="!isFormValid"
          @click="setData()"
          rounded
          color="primary"
          >Guardar cambios</v-btn
        >
      </v-col>
    </v-row>
    <!-- Si es video de stream -->
    <v-row v-if="'EN VIVO' == filter" justify="center">
      <v-col cols="12" lg="6" md="8" sm="10">
        <v-card color="rgba(255,255,255,0.7)" elevation="10" rounded="xl">
          <v-form v-model="isFormValid">
            <v-container>
              <!-- Nombre del video -->
              <p class="form-subtitle"><b>Nombre del Video</b></p>
              <v-text-field
                class="field centered_input"
                required
                v-model="name"
                :rules="nameRules"
                type="text-center"
                clearable
              />
              <!-- Descripcion -->
              <p class="form-subtitle"><b>Descripción</b></p>
              <v-text-field
                class="field centered_input"
                required
                v-model="description"
                :rules="descriptionRules"
                type="text-center"
                clearable
              />
              <!-- Instructora -->
              <p class="form-subtitle"><b>Instructor(es)</b></p>
              <v-select
                class="field centered_input"
                v-model="instructor"
                outlined
                placeholder="Selecciona una opción"
                :items="instructors"
              >
                <template v-slot:selection="{ item }">
                  <span
                    style="
                      color: rgb(44, 81, 213);
                      text-align: center;
                      width: 100%;
                    "
                    >{{ item }}</span
                  >
                </template>
              </v-select>
              <!-- Fecha del video -->
              <p class="form-subtitle">
                <b>Fecha del video:</b>
                <br />
                <v-date-picker
                  v-model="datePicker"
                  color="green lighten-1"
                ></v-date-picker>
              </p>
              <!-- Categoria -->
              <p class="form-subtitle"><b>Categoria</b></p>
              <v-select
                class="field centered_input"
                v-model="category"
                outlined
                placeholder="Selecciona una opción"
                :items="categorys"
              >
                <template v-slot:selection="{ item }">
                  <span
                    style="
                      color: rgb(44, 81, 213);
                      text-align: center;
                      width: 100%;
                    "
                    >{{ item }}</span
                  >
                </template>
              </v-select>

              <!-- CARPETAS -->
              <p class="form-subtitle"><b>Pertenece A:</b></p>
              <v-dialog v-model="dialog" max-width="290">
                <template v-slot:activator="{ on, attrs }">
                  <v-btn color="primary" dark v-bind="attrs" v-on="on">
                    Agregar Nueva Carpeta
                  </v-btn>
                </template>
                <v-card color="white">
                  <p class="form-subtitle"><b>Nueva Carpeta:</b></p>
                  <v-text-field
                    class="field centered_input"
                    required
                    v-model="newFolder"
                    :rules="descriptionRules"
                    type="text-center"
                    clearable
                  />
                  <v-btn class="mx-1" fab dark  small color="green" @click="saveNewFolder">
                    <v-icon dark> mdi-plus </v-icon>
                  </v-btn>
                  <br/>
                </v-card>
                <div
                  id="divider"
                  style="
                    background-color: black;
                    height: 0.5rem;
                    width: 80%;
                    margin: auto;
                  "
                ></div>
                <v-list>
                  <v-header>CARPETAS EXISTENTES</v-header>
                  <v-list-item v-for="item in folders" :key="item">
                    <v-list-item-content>
                      <v-list-item-title v-text="item">*</v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-dialog>
              <br /><br />
              <v-select
                class="field centered_input"
                v-model="serie"
                outlined
                placeholder="Selecciona una opción"
                :items="folders"
              >
                <template v-slot:selection="{ item }">
                  <span
                    style="
                      color: rgb(44, 81, 213);
                      text-align: center;
                      width: 100%;
                    "
                    >{{ item }}</span
                  >
                </template>
              </v-select>
            </v-container>
          </v-form>

          <br />
          <!-- CARD DE LA IMAGEN --- Miniatura --->
          <p class="form-subtitle"><b>Miniatura</b></p>
          <img alt="Avatar" class="rouded" :src="this.url_img" width="50%" />
          <v-spacer />
          <v-progress-linear v-model="UploadValue"></v-progress-linear>
          <v-spacer />
          <input type="file" @change="onFileSelected" />
          <!-- CARD DE LA IMAGEN --- Video --->
          <p class="form-subtitle"><b>URL de En Vivo:</b></p>

          <v-text-field
            class="field centered_input"
            required
            v-model="streamurl"
            :rules="descriptionRules"
            type="text-center"
            clearable
          />
          <v-spacer />

          <!-- numero de video -->
          <p class="form-subtitle"><b>Número de Video:</b></p>
          <v-text-field
            class="field centered_input"
            v-model="numbervideo"
            type="text-center"
            clearable
          />
        </v-card>
        <br />
        <!-- BOTON DE GUARAR -->
        <v-btn
          :disabled="!isFormValid"
          @click="setDataStream()"
          rounded
          color="primary"
          >Guardar cambios</v-btn
        >
      </v-col>
    </v-row>
  </v-app>
</template>
<script>
import navBar from "@/components/navbar";
import firebase from "firebase";
import { db } from "@/main";
import * as faker from "faker";
export default {
  components: { navBar },
  data() {
    return {
      filter: "",
      filters: ["VIDEO", "EN VIVO"],
      datePicker: "",
      isFormValid: false,
      flag_video: false,
      instructor: "",
      instructors: ["Paulina", "Ale", "Maritza"],
      newFolder: "",
      name: "",
      nameRules: [(v) => !!v || "Campo vacio"],
      description: "",
      descriptionRules: [(v) => !!v || "Campo vacio"],
      teacher: "",
      teacherRules: [(v) => !!v || "Campo vacio"],
      tag: "",
      tags: [],
      tagsRules: [(v) => !!v || "Campo vacio"],
      categorys: [
        "Barre Clásico",
        "Cardio Barre",
        "Barre HIIT",
        "Beat Barre",
        "Express"
      ],
      folders: [],
      folder: "",
      category: "",
      categoryRules: [(v) => !!v || "Campo vacio"],
      UploadValue: 0,
      UploadValueVideo: 0,
      url_img: "",
      url_video: "",
      numbervideo: "",
      serie: "",
      streamurl: "",
    };
  },
  methods: {
    async saveNewFolder () {
      const dataFolder = {
        name: this.newFolder
        
      } 
      await db
        .collection("folders")
        .doc(faker.random.alphaNumeric(16))
        .set(dataFolder)
        .then(() => {
          this.newFolder = ''
          setTimeout(async() => {
            this.folders = []
            await this.getFolders()
            alert("Carpeta agregada correctamente");
          }, 1500);
        });
    },
    async getFolders () {
      await db
      .collection("folders")
      .get()
      .then(async (folderName) => {
        console.log("a ver que hay aqui:::", folderName);
        folderName.forEach(async (elementFolder) => {
          console.log("a ver", elementFolder);
          await db
            .collection("folders")
            .doc(elementFolder.id)
            .get()
            .then(async (folderName2) => {
              console.log("a ver2", folderName2.data());
              this.folders.push(folderName2.data().name);
            });
        });
      });
    },
    setDataStream: async function () {
      const dataVideo = {
        video_type: "Stream",
        video_name: this.name,
        description: this.description,
        upload_at: new Date(),
        video_date: this.datePicker,
        instructor: this.instructor,
        category: this.category,
        thumbnail: this.url_img,
        serie: this.serie,
        video_number: this.numbervideo,
        video_url: this.streamurl,
        id: faker.random.alphaNumeric(16),
        uid: this.$store.state.authModule.user.uid,
        enabled: true,
      };
      await db
        .collection("videos")
        .doc(dataVideo.id)
        .set(dataVideo)
        .then(() => {
          this.description = "";
          this.instructor = "";
          this.url_img = "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg";
          this.name = "";
          this.numbervideo = "";
          this.streamurl = "";
          this.serie = "";
          this.category = "";
          this.datePicker = "";
          setTimeout(() => {
            alert("Video agregado correctamente");
          }, 1500);
        });
    },
    setData: async function () {
      const dataVideo = {
        video_type: "videos",
        video_name: this.name,
        description: this.description,
        upload_at: new Date(),
        instructor: this.instructor,
        category: this.category,
        video_date: this.datePicker,
        thumbnail: this.url_img,
        serie: this.serie,
        video_number: this.numbervideo,
        video_url: this.url_video ? this.url_video : this.streamurl,
        id: faker.random.alphaNumeric(16),
        uid: this.$store.state.authModule.user.uid,
        enabled: true,
      };
      await db
        .collection("videos")
        .doc(dataVideo.id)
        .set(dataVideo)
        .then(() => {
          this.description = "";
          this.instructor = "";
          this.url_img = "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg";
          this.name = "";
          this.numbervideo = "";
          this.url_video = "";
          this.streamurl = "";
          this.serie = "";
          this.category = "";
          this.datePicker = "";
          setTimeout(() => {
            alert("Video agregado correctamente");
          }, 1500);
        });
    },
    //metodo para subir la imagen seleccionada en el storage de firebase, cargar la barra de progreso y obtener la url de la imagen
    onFileSelected(event) {
      this.selectedFile = event.target.files[0];
      const storageRef = firebase
        .storage()
        .ref(`/thumbnails/${this.selectedFile.name}`);
      const task = storageRef.put(this.selectedFile);
      task.on(
        "state_changed",
        (snapshot) => {
          let percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.UploadValue = percentage;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.UploadValue = 100;

          task.snapshot.ref.getDownloadURL().then((url) => {
            this.url_img = url;
          });
        }
      );
    },
    onFileSelectedVideo(event) {
      this.selectedFile = event.target.files[0];
    },
    selectFilter() {
      this.flagstream = !this.flagstream;
    },
    uploadBtn(event) {
      const storageRef = firebase
        .storage()
        .ref(`/videos/${this.selectedFile.name}`);
      const task = storageRef.put(this.selectedFile);
      task.on(
        "state_changed",
        (snapshot) => {
          let percentage =
            (snapshot.bytesTransferred / snapshot.totalBytes) * 100;
          this.UploadValueVideo = percentage;
        },
        (error) => {
          console.log(error.message);
        },
        () => {
          this.UploadValueVideo = 100;
          this.flag_video = true;
          task.snapshot.ref.getDownloadURL().then((url) => {
            this.url_video = url;
          });
        }
      );
    },
  },
  async mounted() {
    this.url_img = "https://cdn.vuetifyjs.com/images/cards/sunshine.jpg";
    await this.getFolders()
  },
};
</script>
<style scoped>
#backGND {
  background-image: url("../assets/back.png");
  background-size: cover;
  background-repeat: no-repeat;
  background-position: center center;
  margin-top: auto;
}
.field {
  margin-top: -20px;
}
.centered_input input {
  text-align: center;
}
.field-label {
  margin-top: -15px;
}
#triangle {
  height: 10rem;
  background: linear-gradient(
    to top left,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    #000000 50%,
    #000000 100%
  );
}
.rotate {
  transform: rotate(-5deg);
}
#triangle_down {
  height: 10rem;

  background: linear-gradient(
    to top right,
    rgba(255, 0, 0, 0) 0%,
    rgba(255, 0, 0, 0) 50%,
    rgba(200, 200, 200, 1) 50%,
    rgba(200, 200, 200, 1) 100%
  );
}
</style>



// WEBPACK FOOTER //
// src/components/uploadvideo.vue